import { FormContainer, LabeledInput, Worksheet } from "uikit"
import React from "react"
import { Dropdown, Input } from "semantic-ui-react"
import { useStore } from "store"
import { AddPersonModal } from "../../../people/AddPersonModal"
import { Footer } from "./Footer"

const PensionPlanForm = ({
  data: {
    fields: { description, person_id, monthly_amount, percent_taxable },
    isModified,
    onSubmit,
    error
  },
  submitLabel = "Done",
  isNew,
  onDelete,
  peopleOptions,
  addNewPerson
}) => {
  return (
    <Worksheet error={error}>
      <Worksheet.Body>
        <Worksheet.Row label="Name of the pension?" paddedField>
          <Worksheet.Field error={description.error}>
            <Input {...description} autoComplete="off" />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row label="Person receiving the benefit" paddedField>
          <Worksheet.Field error={person_id.error}>
            <Dropdown
              {...person_id}
              placeholder="Person"
              options={peopleOptions}
              selection
              data-testid="accountOwner"
            />
            {person_id.value === "__ADD__" && (
              <AddPersonModal
                submit={personValues =>
                  addNewPerson(personValues).then(({ personId }) =>
                    person_id.onChange(null, { value: personId })
                  )
                }
                onCancel={() => person_id.onChange(null, { value: null })}
              />
            )}
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="Monthly benefit amount"
          paddedField
          description="What is the estimated monthly benefit at full retirement age?"
        >
          <Worksheet.Field error={monthly_amount.error}>
            <LabeledInput
              {...monthly_amount}
              label=""
              iconText="$"
              iconPosition="left"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
        <Worksheet.Row
          label="What percentage of the pension income is taxable?"
          paddedField
        >
          <Worksheet.Field error={percent_taxable.error} padded>
            <LabeledInput
              {...percent_taxable}
              label=""
              iconText="%"
              placeholder="0"
            />
          </Worksheet.Field>
        </Worksheet.Row>
      </Worksheet.Body>
      <Footer
        isNew={isNew}
        submitLabel={submitLabel}
        onSubmit={onSubmit}
        onDelete={onDelete}
        isModified={isModified}
        deleteLabel="Delete Benefit"
        error={error}
      />
    </Worksheet>
  )
}

const PensionPlanFormContainer = FormContainer(
  {
    description: {
      type: "string"
    },
    person_id: {
      type: "string"
    },
    monthly_amount: {
      type: "unit"
    },
    percent_taxable: {
      type: "decimal",
      minValue: 0,
      maxValue: 100,
      defaultValue: 100
    }
  },
  (fields, ...form) => {}
)(PensionPlanForm)

const PensionPlan = ({ household, type, benefit, ...formProps }) => {
  const [
    people,
    { addBenefit, deleteBenefit, updateBenefit, addPerson }
  ] = useStore("householdPeople", household.id)

  const isNew = benefit === null
  const values = isNew
    ? {
        person_id: people.length === 1 ? people[0].id : null,
        monthly_amount: null
      }
    : benefit
  const peopleOptions = Object.values(people)
    .filter(({ role }) => role === "spouse" || role === "client")
    .map(({ id: value, first_name: text }) => ({
      value,
      text
    }))
  const canAddPerson = false
  const submit = isNew
    ? async values =>
        await addBenefit({
          household_id: household.id,
          type,
          ...values
        })
    : async values =>
        await updateBenefit({
          id: benefit.id,
          type,
          ...values
        })

  const onDelete = () =>
    deleteBenefit({
      id: benefit.id,
      household_id: household.id
    })
  if (canAddPerson) {
    peopleOptions.push({ text: "Add person...", value: "__ADD__" })
  }
  const addNewPerson = values =>
    addPerson({ household_id: household.id, ...values })
  return (
    <PensionPlanFormContainer
      {...{
        isNew,
        submit,
        onDelete,
        values,
        peopleOptions,
        household,
        addNewPerson,
        ...formProps
      }}
    />
  )
}
export default PensionPlan
